import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { tenantProvisioningService } from '@/services/control/tenant-provisioning-service';
import type {
  AuthConfigInput,
  TenantAuthSettings,
} from '@/types/control/tenant-provisioning';

import { adminMutationKeys, adminQueryKeys } from '@/hooks/admin/query-keys';

/**
 * Correct a tenant's auth settings after creation. Read-after-write from the
 * same store the GET reads, so invalidating the one key is enough; no polling.
 */
export function useUpdateTenantAuth(
  tenantId: string
): UseMutationResult<TenantAuthSettings, Error, AuthConfigInput> {
  const queryClient = useQueryClient();

  return useMutation<TenantAuthSettings, Error, AuthConfigInput>({
    mutationKey: adminMutationKeys.updateTenantAuth(tenantId),
    mutationFn: (authConfig) =>
      tenantProvisioningService.updateAuth(tenantId, authConfig),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: adminQueryKeys.tenantAuth(tenantId),
      }),
  });
}
